import { render, staticRenderFns } from "./wo002Detail01Tab02.vue?vue&type=template&id=b2213342"
import script from "./wo002Detail01Tab02.vue?vue&type=script&lang=js"
export * from "./wo002Detail01Tab02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2213342')) {
      api.createRecord('b2213342', component.options)
    } else {
      api.reload('b2213342', component.options)
    }
    module.hot.accept("./wo002Detail01Tab02.vue?vue&type=template&id=b2213342", function () {
      api.rerender('b2213342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/imsi/sample/wo002Detail01Tab02.vue"
export default component.exports